export default __webpack_public_path__ + "e47fa358bcb1b7050c17665eb9c3c613.jpg";